import React from "react";

function About() {
  return (
    <div>
      <a
        className="uppercase hover:underline"
        href="https://reactjs.org"
        target="_blank"
        rel="noopener noreferrer"
      >
        About Page Route
      </a>
    </div>
  );
}

export default About;
